import _Toast from "@ks/sharp-ui/lib/toast";
import _Button from "@ks/sharp-ui/lib/button";
import _Dialog from "@ks/sharp-ui/lib/dialog";
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import '@ks/sharp-ui/themes/default/icon.scss';
import '@ks/sharp-ui/themes/default/toast.scss';
import '@ks/sharp-ui/themes/default/dialog.scss';
import '@ks/sharp-ui/themes/default/button.scss';
import { weblog } from './weblog';

if (process.env.NODE_ENV === 'development' || process.env.SHOW_VCONSOLE === 'true') {
  var vConsole = require('vconsole');

  new vConsole(); // eslint-disable-line
}

var _oldOnError = Vue.config.errorHandler;

Vue.config.errorHandler = function (err, vm, info) {
  // radar上报
  weblog.plugins.radar.captureException(err); // 执行原来的errorHandler

  if (typeof _oldOnError === 'function') {
    _oldOnError.call(this, err, vm, info);
  } // 输出控制台


  if (process.env.NODE_ENV !== 'production') {
    console.error(err);
  }
};

Vue.use(_Dialog);
Vue.use(_Button);
Vue.prototype.$toast = _Toast;
Vue.prototype.$dialog = _Dialog;
Vue.prototype.$log = weblog;
Vue.config.productionTip = false;
new Vue({
  el: '#app',
  router: router,
  components: {
    App: App
  },
  template: '<App/>'
});